'use client';

import { useRouter } from '@bprogress/next';
import Input from '@ui/Input';
import { FAQTopic, QUESTION_TOPIC_MAP } from '@util/maps/faq';
import { getFaqUrl } from '@util/urlHelpers';
import { AnimatePresence } from 'framer-motion';
import { MotionDiv } from 'motion';
import { useState } from 'react';

function findFAQs(searchInput: string): { q: string; topic: FAQTopic }[] {
  const matchingQuestions = Object.keys(QUESTION_TOPIC_MAP).filter((q) => {
    const lowerCaseSearchInput = searchInput.toLowerCase().trim();
    const lowerCaseQuestion = q.toLowerCase();
    return lowerCaseQuestion.includes(lowerCaseSearchInput);
  });
  const results = matchingQuestions.map((q) => ({
    q,
    topic: QUESTION_TOPIC_MAP[q],
  }));
  return results;
}

export const SearchField = () => {
  const [searchInput, setSearchInput] = useState('');
  const [focus, setFocus] = useState(false);
  const results = findFAQs(searchInput);
  const router = useRouter();
  function navigate(topic: FAQTopic, q: string) {
    const href = getFaqUrl(topic, q);
    router.push(href);
  }
  return (
    <div className=" w-full max-w-[540px]">
      <Input
        type="search"
        placeholder="Search Motorsport Locker help center"
        full
        className="!rounded-[12px] text-body-md font-medium"
        onChange={(e) => setSearchInput(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
      />
      <AnimatePresence>
        {focus && searchInput && (
          <MotionDiv
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-[2rem] h-fit w-full cursor-pointer overflow-clip !rounded-[12px] border border-brand-darker-white bg-brand-white shadow-lg"
          >
            <div className="flex max-h-[25rem] flex-col overflow-y-scroll">
              {!!results.length &&
                results.map((result, i) => (
                  <div
                    key={i}
                    className="w-full py-4 pl-8 text-left hover:bg-brand-darker-white"
                    onMouseDown={() => navigate(result.topic, result.q)}
                  >
                    {result.q}
                  </div>
                ))}
              {!results.length && (
                <div className="w-full py-4 pl-8 text-left">
                  No results found
                </div>
              )}
            </div>
          </MotionDiv>
        )}
      </AnimatePresence>
    </div>
  );
};
